import { $serviceTitan } from "@/utils/https.js";
// 用户调查
export function createSurvey(data) {
    return $serviceTitan().post(`/api/titan/manage/user/survey`, data);
}

export function getSurveys(params) {
    return $serviceTitan().get(`/api/titan/manage/user/survey`, { params });
}

export function updateSurvey(id, data) {
    return $serviceTitan().put(`/api/titan/manage/user/survey/${id}`, data);
}

export function deleteSurvey(ids) {
    return $serviceTitan().delete(`/api/titan/manage/user/survey`, { params: { ids: ids + "" } });
}

export function getSurvey(id) {
    return $serviceTitan().get(`/api/titan/manage/user/survey/${id}`);
}

export function remarkSurvey(id, data) {
    return $serviceTitan().put(`/api/titan/manage/user/survey/${id}/remark`, data);
}

export function updateSurveyStatus(id, data) {
    return $serviceTitan().put(`/api/titan/manage/user/survey/${id}/status`, data);
}

export function getSurveyStat() {
    return $serviceTitan().get(`/api/titan/manage/user/survey/stat`);
}
